import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Row, Button } from 'react-bootstrap'
import Newsletter from '../../../containers/NewsletterWidget'
import Item from './item'
import MoreButton  from '../../Buttons/plus'
import LessButton  from '../../Buttons/less'
import ActionBar from '../../../containers/Sections/Imi/actionBar'
import Spinner from '../../Spinner'
import { translate } from "react-translate"

@translate("Imi")
export default class Imi extends Component {

  constructor (props) {
    super(props)

    this.state = {
      viewMore: false
    }
    this.handleMoreElements = this.handleMoreElements.bind(this)
  }

  handleMoreElements(event) {
    this.setState({viewMore: !this.state.viewMore});
  }

  componentWillMount() {
    window.scrollTo(0,0)
		this.props.loadImis(8);
  }

  handleClick(e,total){
    e.preventDefault()
    this.props.loadImisByPagination(total)
  }

  render () {

    const { list, current_page, last_page, total, saveInform, t, loading } = this.props

    let baseUrl = window.location.origin;
    let informeUrl = baseUrl + '/informes-del-mercado-inmobiliario';

        return (
          <div id="top" name="top" className="imi container-fluid">
            <ol className="route-info hidden-xs" itemScope itemType="http://schema.org/BreadcrumbList">
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                <a href={ baseUrl } itemProp="item" itemType="http://schema.org/Thing">
                  <span itemProp="name"><small>{t("Informacion_Novedades")}</small></span>
                  <meta itemProp="position" content="1" />
                </a>
              </li>
              <i className="fa fa-angle-right"></i>
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                <a href={ informeUrl } itemProp="item" itemType="http://schema.org/Thing">
                  <span itemProp="name"><small>{t("Informes_Mercado")}</small></span>
                  <meta itemProp="position" content="2" />
                </a>
              </li>
            </ol>
            
            <div className="list-info-container">
              <h2 className="list-title">{t("Informes_Mercado")}</h2>
              <ActionBar />
							{(loading)?(<Spinner />):""}
							{(list.length === 0)?(
								<div className="col-md-12 col-error">
									<div className="no-properties-box">
		                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
		                <p>{t("No_IMIS")}</p>
		              </div>
								</div>
							):(
								<div>
								{(!loading)?(
									<div>
									{list.map((item, index) =>
										<Col md={3} sm={6} key={index}>
											<Item {...item} />
										</Col>
									)}
									</div>
								):""}
								</div>
							)}
            </div>
            { (current_page === last_page) ? '' : (
              <div className={"btn-more-container hidden-xs" + (this.state.viewMore ? ' hide-button' : '')}>
                <MoreButton onClickMore={(e) => this.handleClick(e, total)} />
              </div> )
            }
            <div className="btn-more-container visible-xs">
              <Link className="btn btn-menu"><span className="btn-informe">{t("Ver_Mas")}</span></Link>
            </div>
            <div className="informes-mercado-container">
              <Row>
                <Col md={12} sm={12}>
                  <h3 className="text-center">{t("Imi_Titulo_Principal")}</h3>
                  <p>{t("Imi_Texto_Parrafo_1")}</p>
                  <p>{t("Imi_Texto_Parrafo_2")}</p>
                </Col>
              </Row>
            </div>
            <div className="form-newsletter-container">
              <Newsletter />
            </div>
          </div>
        )


  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Imi/index.js